import { Component, Input, OnInit} from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-esim-your-order',
  templateUrl: './esim-your-order.component.html',
  styleUrls: ['./esim-your-order.component.scss']
})
export class EsimYourOrderComponent implements OnInit {
  numberOfItemsInCart: any;
  shoppingCart: any;
  shipmentGroupList: any = [];
  cartContainsVisitorLine: boolean = false;
  visitorLineTravelAddon: any;
  isTravelInsuranceAddon: boolean =false;
  @Input() orderreview:boolean = false;
  currentLanguage: any;
  totaldays: any;
  items: any;
  constructor(private UTS: UtilitiesService,private CS: CartService,) {
    this.init()
   }
  ngOnInit(): void {
    this.currentLanguage  = this.UTS.getLocaleLanguage().toLowerCase();
  }
  init() {
    this.CS.getShoppingCart().subscribe(
      (response: any) => {
        this.shoppingCart = response;
        this.items = this.shoppingCart?.items
        this.numberOfItemsInCart = response.numberOfItemsInCart
          ? response.numberOfItemsInCart
          : 0;


        if (this.numberOfItemsInCart == 0) {
          window.location.href = environment.HOST + '/b2c/eshop/viewProducts';
        } else {
          this.shoppingCart = response;
          this.items = this.shoppingCart?.items
          if( this.shoppingCart && this.shoppingCart.items){
            this.cartContainsVisitorLine =this.shoppingCart.items.find(
               (x) =>
                 x?.commerceItemCategory== "Visitor_line_plan"
             )
           }
           var  lineExpiry =this.shoppingCart.items.filter(
            (x) =>
              x?.lineExpiry
          )
          if (lineExpiry && lineExpiry.length > 0 && lineExpiry[0]?.lineExpiry) {
            var GivenDate = lineExpiry[0]?.lineExpiry;
            var CurrentDate = new Date();
            GivenDate = new Date(GivenDate);
            if(GivenDate > CurrentDate){
              let Difference_In_Time = GivenDate.getTime() - CurrentDate.getTime();
              this.totaldays =Math.round(Difference_In_Time / (1000 * 3600 * 24));
            }
          }
          this.shoppingCart.items =
            this.shoppingCart.items &&
            this.shoppingCart.items.map((a) => {
              a['checked'] = false;
              return a;
            });

          this.shipmentGroupList = this.groupBy(
            this.shoppingCart.items,
            (item) => {
              if (item.isPreOrder) {
                return [item.preOrderEndDate];
              } else {
                return null;
              }
            }
          );
          // }

          for (var i = 0; i < this.shipmentGroupList.length; i++) {
            let groupedItems = this.CS.getGroupedCommerceItems(
              this.shipmentGroupList[i]
            );
            this.shipmentGroupList[i] = groupedItems;
          }

        }
      },
      (e) => {
        if (e && e.error) {
          this.UTS.error(e.error.message);
        }
      }
    );
  }
  groupBy(shoppingCart, f) {
    let groups = [];
    shoppingCart.forEach((o) => {
      if (
        (typeof o.isProduct != 'undefined' && o.isProduct == true) ||
        o.commerceItemType === 'bookYourNumber' ||
        o.commerceItemType === 'mobilePlanSku'
      ) {
        const group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      }
    });
    return Object.keys(groups).map((group) => {
      groups[group][0].deliveryTimeSelected = 'Morning';
      return {
        items: groups[group],
        shipDateAndTime: { shipTime: groups[group][0].deliveryTimeSelected },
      };
    });
  }
  addConfigurationsToName(commerceItem) {
    let name = commerceItem.brand + ' ' + commerceItem.parentDisplayName;
    if (commerceItem.configurations) {
      return name;
    } else {
      return this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'ar'
        ? commerceItem.displayNameAr || commerceItem.displayName
        : commerceItem.displayName;
    }
  }
}
